<template>
  <b-sidebar
    :id="idSidebar"
    bg-variant="white"
    sidebar-class="sidebar-xl"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1 border-left-primary border-left-5">
        <h5 class="mb-0">
          Contenido temático
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="20"
          @click="hide"
        />
      </div>

      <blockquote class="blockquote pl-1 pt-2 pb-2 text-left border-left-primary border-left-5">
        <p class="mb-0">
          {{ materia.nombre }}
        </p>
        <footer class="blockquote-footer">
          Clave
          <cite title="Source Title">{{ materia.clave }}</cite>
        </footer>
      </blockquote>

      <app-timeline class="p-1">
        <app-timeline-item
          v-for="modulo in materia.modulos"
          :key="modulo.id"
        >
          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6><b>{{ modulo.titulo }}</b></h6>
          </div>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="modulo.descripcion" />
          <!-- eslint-enable -->
        </app-timeline-item>
      </app-timeline>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, VBToggle,
} from 'bootstrap-vue'
// import Ripple from 'vue-ripple-directive'
// import {BButton, BSidebar, VBToggle} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BSidebar,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  props: {
    idSidebar: {
      type: String,
      required: true,
    },
    materia: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
}
</script>
